import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useStore from "store/hook";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import api from "store/api/api";
import { Collapse, DialogActions, Typography } from "@mui/material";
import SoftButton from "components/SoftButton";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SoftInput from "components/SoftInput";
import CircularLoader from "./Loader";
import { ReactComponent as EmptyFolderIcon } from "assets/images/small-logos/icon-emptyFolder.svg";
import { toast } from "react-toastify";
import checkboxgreen from "assets/images/logos/checkboxgreen.png";
import checkboxwhite from "assets/images/logos/checkboxwhite.png";

export default function SelectDicipline({
  discipline,
  setDiscipline,
  newImages,
  setNewImages,
  addInspectionData,
  setAddInspectionData,
  inspectionDetails,
  setInspectionDetails,
}) {
  const { store, setDialogue } = useStore();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [selectedDiscipline, setSelectedDisciplie] = React.useState({
    comment: "",
    images: [],
    location: "",
    disciplineName: "",
    notes: "",
    inspectionType: "",
  });
  const [innerStatus, setInnerStatus] = React.useState("");
  const [deficiencyFound, setDeficiencyFound] = React.useState([]);

  const [inspectiontype, SetInspectionType] = React.useState([]);
  const [comments, setComments] = React.useState([]);
  const [predefinedCommentType, setPredefinedCommentType] =
    React.useState("approved");
  const predefinedCommentTypeStyles = {
    approved: {
      label: "Approved",
      color: "#2E7D32",
    },
    failed: {
      label: "Failed",
      color: "#D32F2F",
    },
  };

  const [disciplineData, setdisciplineData] = React.useState([]);
  const [disciplineId, setdisciplineId] = React.useState([]);

  const [newlyAddedImages, setNewlyAddedImages] = React.useState([]);

  const {
    isOpen = false,
    selectedDicipline,
    action,
    isAdddiscipline,
  } = store?.app?.dialogs?.selectDicipline || {};

  const { isaddDicipline } = store?.app?.dialogs?.addDicipline || {};
  const { isaddLocation } = store?.app?.dialogs?.addLocation || {};
  const { isOpencomment, addComment, isAddcomment, predefinedcomments } =
    store?.app?.dialogs?.addComment || {};

  // Find the discipline matching selectedDiscipline.name and update location
  const selectedItem = disciplineData?.find(
    (item) => item?.disciplineName === selectedDiscipline?.disciplineName
  );

  React.useEffect(() => {
    if (discipline && discipline[selectedDicipline] && !isAdddiscipline) {
      setSelectedDisciplie({
        comment: discipline[selectedDicipline].comment || "",
        images: discipline[selectedDicipline].images || [],
        location: discipline[selectedDicipline].location || "",
        disciplineName: discipline[selectedDicipline].disciplineName || "",
        notes: discipline[selectedDicipline].notes || "",
        inspectionType: discipline[selectedDicipline].inspectionType || "",
      });
    }

    if (discipline?.length > 0) {
      setSelectedDisciplie((prev) => ({
        ...prev,
        disciplineName: discipline[0].disciplineName || "",
      }));
    }

    if (action == "addInspection") {
      setInnerStatus(addInspectionData?.inner_status);
      setDeficiencyFound(addInspectionData?.deficiencies_found);
    }

    if (action == "updateInspection") {
      setInnerStatus(inspectionDetails?.inner_status);
      setDeficiencyFound(inspectionDetails?.deficiencyFound);
    }

    fetchInspectionDetails();

    selectedItem && SetInspectionType(selectedItem?.inspectionTypes);
  }, [isOpen, isaddDicipline, isaddLocation]);

  React.useEffect(() => {
    if (disciplineData.length > 0 && selectedDiscipline?.disciplineName) {
      const newItem = disciplineData.find(
        (item) => item?.name === selectedDiscipline?.disciplineName
      );
      SetInspectionType(newItem?.inspectionTypes || []);
      setdisciplineId(newItem?.discipline_id || "");
      setComments(newItem?.comments || []);
    }
  }, [disciplineData, selectedDiscipline, isaddLocation]);

  const handleClose = () => {
    setNewImages([]);
    setNewlyAddedImages([]);
    setSelectedDisciplie({});
    setInnerStatus("");
    setDialogue({
      type: "selectDicipline",
      isOpen: false,
      selectedDicipline: "",
    });
  };

  const handleOpenAddDicipline = () => {
    setDialogue({
      type: "addDicipline",
      isOpen: true,
      isaddDicipline: true,
    });
  };

  const handleOpenAddLocation = () => {
    setDialogue({
      type: "addLocation",
      isOpen: true,
      disciplineId: disciplineId,
      isaddLocation: true,
    });
  };

  const getCommentType = (comment) =>
    comment?.comment_type || (comment?.status === "failed" ? "failed" : "approved");

  const setPredefinedComments = (commentType = "approved") => {
    setPredefinedCommentType(commentType);
    setDialogue({
      type: "addComment",
      isOpencomment: true,
      addComment: selectedDiscipline?.comment || "",
      predefinedcomments:
        comments?.filter(
          (comment) =>
            (comment?.type || "pre_defined") === "pre_defined" &&
            getCommentType(comment) === commentType
        ) || [],
      isAddcomment: true,
    });
  };

  const handleOpenPredefinedComment = () => {
    setDialogue({
      type: "addComment",
      isOpencomment: true,
      addComment: selectedDiscipline?.comment || "",
      predefinedcomments: [],
      isAddcomment: true,
    });
    setPredefinedComments("approved");
  };

  const fetchInspectionDetails = async () => {
    try {
      const response = await api.getDisciplineData();
      setdisciplineData(response?.data);
    } catch (error) {
      console.error("Error in fetching details", error);
    }
  };

  const ChangeData = () => {
    let isvalid = true;

    if (deficiencyFound?.length <= 0) {
      toast.error("Please select the deficiencies found option");
      isvalid = false;
    } else if (selectedDiscipline.disciplineName == "") {
      toast.error("Please select the  name of the discipline");
      isvalid = false;
    } else if (
      !selectedDiscipline.inspectionType ||
      selectedDiscipline.inspectionType == ""
    ) {
      toast.error("Please select the type  of the inspection");
      isvalid = false;
    } else if (
      !selectedDiscipline.location ||
      selectedDiscipline.location == ""
    ) {
      toast.error("Please enter the location name");
      isvalid = false;
    } else if (
      !selectedDiscipline.comment ||
      selectedDiscipline.comment == ""
    ) {
      toast.error("Please enter the comments");
      isvalid = false;
    } else {
      if (isvalid) {
        if (!isAdddiscipline) {
          setDiscipline(() =>
            discipline.map((item, i) =>
              i === selectedDicipline ? selectedDiscipline : item
            )
          );
        } else if (isAdddiscipline) {
          setDiscipline((prev) => [...prev, selectedDiscipline]);
        }

        if (action == "addInspection") {
          setAddInspectionData((prev) => ({
            ...prev,
            inner_status: innerStatus,
            deficiencies_found: deficiencyFound,
          }));
        }

        if (action == "updateInspection") {
          setInspectionDetails((prev) => ({
            ...prev,
            inner_status: innerStatus,
            deficiencyFound: deficiencyFound,
          }));
        }

        setSelectedDisciplie({});
        setInnerStatus("");

        return true;
      } else {
        return false;
      }
    }
  };

  const handleChangeInspectionType = (newInspectiontype) => {
    setSelectedDisciplie((prev) => ({
      ...prev,
      inspectionType: newInspectiontype,
    }));
  };

  const handleCangeDisciplie = (newdisciplie) => {
    if (isAdddiscipline && discipline?.length > 0) {
      toast.error(
        "You cannot modify an existing discipline while adding multiple disciplines simultaneously."
      );
    } else if (!isAdddiscipline && discipline?.length > 1) {
      toast.error(
        "You cannot modify an existing discipline while adding multiple disciplines simultaneously."
      );
    } else {
      setSelectedDisciplie((prev) => ({
        ...prev,
        disciplineName: newdisciplie?.name,
        inspectionType: "",
      }));
    }
  };

  const handleUpdateDiscipline = () => {
    setLoading(true);

    const isChangeData = ChangeData();

    if (isChangeData) {
      setDialogue({
        type: "selectDicipline",
        isOpen: false,
        selectedDicipline: "",
      });
      setLoading(false);
    }

    setLoading(false);
  };

  const handleRemoveImage = (index) => {
    setSelectedDisciplie((prev) => ({
      ...prev,
      images: prev?.images?.filter((image, i) => i !== index),
    }));
  };

  const handleImageUpload = (e) => {
    const files = e.target.files;

    setSelectedDisciplie((prev) => ({
      ...prev,
      images: [...(prev?.images || []), ...files],
    }));
  };

  const [comment, setComment] = React.useState("");

  React.useEffect(() => {
    setComment(addComment);
  }, [addComment]);

  const handleCloseComment = () => {
    setPredefinedCommentType("approved");
    setDialogue({
      type: "addComment",
      isOpencomment: false,
      addComment: comment,
      predefinedcomments: [],
      isAddcomment: false,
    });
  };

  const handleAppendComment = (comment) => {
    setSelectedDisciplie((prev) => {
      const separator = prev.comment ? "\n" : "";

      const phrasesToRemove = ["Contractor not ready", "Cancelled in route"];

      if (phrasesToRemove.includes(comment)) {
        const prevComment = prev?.comment || "";

        // Split lines and remove any that match our phrases
        const cleanedLines = prevComment
          .split("\n")
          .filter(
            (line) =>
              !phrasesToRemove.some((phrase) =>
                line.toLowerCase().includes(phrase.toLowerCase())
              )
          );

        const alreadyHasComment = prevComment
          .toLowerCase()
          .includes(comment.toLowerCase());

        let newComment;

        if (alreadyHasComment) {
          newComment = cleanedLines.join("\n").trim();
        } else {
          newComment = cleanedLines.length
            ? cleanedLines.join("\n").trim() + separator + comment
            : comment;
        }

        return {
          ...prev,
          comment: newComment,
        };
      } else {
        return {
          ...prev,
          comment: prev?.comment ? prev.comment + separator + comment : comment,
        };
      }
    });

    handleCloseComment();
  };

  const handleDeficiencyFound = (deficiency, isAdd) => {
    if (
      (discipline?.length >= 1 && isAdddiscipline) ||
      (discipline?.length > 1 && !isAdddiscipline)
    ) {
      toast.error(
        "You have added some disciplines after this one. Please remove them first before changing the deficiency found."
      );
    } else {
      if (isAdd) {
        setDeficiencyFound((prev) => [...prev, deficiency]);
      } else if (!isAdd) {
        setDeficiencyFound((prev) =>
          prev.filter((item) => item !== deficiency)
        );
      }
    }
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        aria-labelledby="select-inspector-dialog"
        sx={{
          "& .MuiDialog-paper": {
            margin: 2,
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "white.main",
            padding: "18px 24px !important",
          }}
        >
          <SoftBox display="flex" alignItems="center" justifyContent="center">
            <SoftTypography
              color="lightBlack"
              fontSize="26px"
              fontWeight="bold"
              sx={{ color: "#212121" }}
            >
              SELECT DISCIPLINE
            </SoftTypography>
          </SoftBox>

          {/* Deficiency Found */}

          <SoftBox>
            <SoftBox
              sx={{
                backgroundColor: "white.main",
                overflowY: "auto",
                display: "flex",
                alignItems: {
                  xs: "flex-start",
                  sm: "center",
                },
                justifyContent: "space-between",
              }}
            >
              <SoftTypography
                color="lightBlack"
                fontSize="18px"
                fontWeight="bold"
                sx={{ color: "#212121" }}
              >
                Deficiencies Found:
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          <SoftBox
            display="flex"
            gap="70px"
            sx={{
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: { xs: "20px", sm: "70px" },
            }}
          >
            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mt={1} mr={0.5}>
                {deficiencyFound?.includes("no") ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 18,
                      height: 18,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDeficiencyFound("no", false)}
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 18,
                      height: 18,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDeficiencyFound("no", true)}
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="16px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                No
              </SoftTypography>
            </SoftBox>

            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mt={1} mr={0.5}>
                {deficiencyFound?.includes("yes") ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 18,
                      height: 18,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDeficiencyFound("yes", false)}
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 18,
                      height: 18,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDeficiencyFound("yes", true)}
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="16px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                Yes
                <SoftTypography
                  color="lightBlack"
                  fontSize="16px"
                  fontWeight="regular"
                  display="flex"
                  sx={{ color: "#212121" }}
                >
                  (see comments below)
                </SoftTypography>
              </SoftTypography>
            </SoftBox>

            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mt={1} mr={0.5}>
                {deficiencyFound?.includes("reinspection_required") ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 18,
                      height: 18,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleDeficiencyFound("reinspection_required", false)
                    }
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 18,
                      height: 18,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleDeficiencyFound("reinspection_required", true)
                    }
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="16px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                Re-Inspection Required
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          {/* Reinspection Required */}

          <SoftBox display="flex" flexDirection="column" gap={2}>
            {/* Discipline Data */}
            <SoftBox>
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                  pt={1}
                  textAlign="left"
                >
                  Select Discipline :
                </SoftTypography>

                <SoftTypography
                  color="lightBlack"
                  fontSize="14px"
                  fontWeight="regular"
                  sx={{
                    color: " #737373",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  textAlign="right"
                  onClick={handleOpenAddDicipline}
                >
                  Cant Find Discipline?
                </SoftTypography>
              </SoftBox>

              <SoftBox
                display="grid"
                gridTemplateColumns="repeat(auto-fill, minmax(150px, 1fr))"
                gap={1}
                justifyItems="stretch"
              >
                {disciplineData &&
                  disciplineData?.map((item, index) => (
                    <SoftTypography
                      key={index}
                      fontSize="15px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        borderRadius: "12px",
                        padding: "6px 20px !important",
                        cursor: "pointer",
                        backgroundColor:
                          item?.name === selectedDiscipline?.disciplineName
                            ? "#DBF6E7"
                            : "#F1F4F8",
                        boxShadow:
                          item?.name === selectedDiscipline?.disciplineName
                            ? "0px 4px 4px 0px #00000040"
                            : "none",
                        whiteSpace: "nowrap", // Prevent text from wrapping to the next line
                        overflow: "hidden", // Hide overflowed content
                        textOverflow: "ellipsis", // Add ellipsis to overflowing text
                      }}
                      onClick={() => handleCangeDisciplie(item)}
                    >
                      {item?.name}
                    </SoftTypography>
                  ))}
              </SoftBox>
            </SoftBox>

            {/* Select Inspection Type */}
            <SoftBox>
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                  textAlign="left"
                >
                  Inspection Type :
                </SoftTypography>

                <SoftTypography
                  fontSize="14px"
                  fontWeight="regular"
                  sx={{
                    color: "#737373",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  textAlign="right"
                  onClick={handleOpenAddLocation}
                >
                  Can't Find Inspection type?
                </SoftTypography>
              </SoftBox>

              <Box>
                <SoftBox
                  sx={{
                    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  {/* Dropdown Header */}
                  <Box
                    sx={{
                      backgroundColor: "#F1F4F8",
                      borderRadius: "12px",
                      padding: "0px 15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    onClick={() => setOpen(!open)} // Toggle dropdown on click
                  >
                    {!selectedDiscipline?.inspectionType && (
                      <Typography fontSize="15px" color=" #737373">
                        Choose inspection type
                      </Typography>
                    )}

                    {selectedDiscipline?.inspectionType && (
                      <Typography fontSize="14px">
                        {selectedDiscipline?.inspectionType}
                      </Typography>
                    )}

                    <IconButton
                      onClick={() => setOpen(!open)}
                      sx={{
                        transform: open ? "rotate(180deg)" : "rotate(0deg)", // Rotate icon when open
                        transition: "0.3s ease-in-out",
                      }}
                    >
                      <ExpandMoreIcon
                        sx={{ color: "#000000", width: 28, height: 28 }}
                      />
                    </IconButton>
                  </Box>

                  {/* Dropdown Content */}
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box
                      sx={{
                        backgroundColor: "#FFFFFF",
                        padding: "10px",
                        borderRadius: "0 0 12px 12px",
                      }}
                    >
                      {inspectiontype?.length > 0 ? (
                        inspectiontype.map((item, index) => (
                          <SoftTypography
                            fontSize="14px"
                            color="primary"
                            key={index}
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              handleChangeInspectionType(item?.name);
                              setOpen(!open);
                            }}
                          >
                            {item?.name}
                          </SoftTypography>
                        ))
                      ) : (
                        <SoftBox
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          gap={1}
                        >
                          <SoftTypography
                            fontSize="40px"
                            fontWeight="light"
                            height="50px"
                            color="fade"
                          >
                            0
                          </SoftTypography>
                          <SoftTypography
                            fontSize="20px"
                            fontWeight="medium"
                            color="fade"
                          >
                            Inspection Type
                          </SoftTypography>
                          <EmptyFolderIcon
                            style={{
                              opacity: 0.8,
                              width: "100px",
                              height: "100px",
                            }}
                          />
                        </SoftBox>
                      )}
                    </Box>
                  </Collapse>
                </SoftBox>
              </Box>
            </SoftBox>

            {/* Enter Location */}
            <SoftBox>
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Location :
                </SoftTypography>
              </SoftBox>

              <SoftBox>
                <SoftInput
                  name="location"
                  value={selectedDiscipline?.location}
                  onChange={(e) =>
                    setSelectedDisciplie((prev) => ({
                      ...prev,
                      location: e?.target?.value,
                    }))
                  }
                  placeholder="Enter Location"
                  multiline
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>

            {/* Add Comments */}
            <SoftBox>
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121", whiteSpace: "nowrap" }}
                  textAlign="left"
                >
                  Comment :
                </SoftTypography>

                <SoftTypography
                  color="lightBlack"
                  fontSize="14px"
                  fontWeight="regular"
                  sx={{
                    color: " #737373",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  textAlign="right"
                  onClick={handleOpenPredefinedComment}
                >
                  Pre-Defined Comments
                </SoftTypography>
              </SoftBox>

              <SoftBox>
                <SoftInput
                  name="comment"
                  value={selectedDiscipline?.comment}
                  onChange={(e) =>
                    setSelectedDisciplie((prev) => ({
                      ...prev,
                      comment: e?.target?.value,
                    }))
                  }
                  placeholder="Comments"
                  multiline
                  rows={3}
                  fontSize="18px"
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>

            {/* Add Internal Notes */}
            <SoftBox>
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Notes :
                </SoftTypography>
              </SoftBox>

              <SoftBox>
                <SoftInput
                  name="notes"
                  value={selectedDiscipline?.notes}
                  onChange={(e) =>
                    setSelectedDisciplie((prev) => ({
                      ...prev,
                      notes: e?.target?.value,
                    }))
                  }
                  placeholder="Write additional notes (if any)"
                  multiline
                  rows={3}
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>

            {/* Images Block */}
            {(selectedDiscipline?.images?.length > 0 ||
              newlyAddedImages?.length > 0) && (
              <SoftBox
                display="flex"
                alignItems="center"
                justifyContent="start"
                gap={1.5}
              >
                <SoftButton
                  variant="contained"
                  component="label"
                  sx={{
                    outlined: "none",
                    backgroundColor: "#F1F4F8",
                    width: 80,
                    height: 80,
                    color: "#02255B",
                    borderRadius: "12px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  onChange={handleImageUpload}
                >
                  Choose Photo
                  <input type="file" hidden multiple accept="image/*" />
                </SoftButton>

                <SoftBox display="flex" gap={1} flexWrap="wrap">
                  {selectedDiscipline?.images?.map((image, index) => (
                    <SoftBox position="relative" mt={1}>
                      {/* Remove Button */}
                      <IconButton
                        sx={{
                          position: "absolute",
                          width: 20,
                          height: 20,
                          padding: "5px",
                          backgroundColor: "#f8f8f8",
                          border: "0.63px solid #02255B",
                          boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                          "&:hover": { backgroundColor: "#f8f8f8" },
                        }}
                        onClick={() => handleRemoveImage(index)}
                      >
                        <CloseIcon
                          fontSize="5px"
                          sx={{ color: "#02255B", fontSize: 18 }}
                        />
                      </IconButton>

                      <SoftBox
                        key={index}
                        component="img"
                        src={
                          typeof image === "string"
                            ? image
                            : URL.createObjectURL(image)
                        }
                        sx={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: "12px",
                          border: "0.63px solid #02255B",
                        }}
                      />
                    </SoftBox>
                  ))}
                </SoftBox>
              </SoftBox>
            )}

            {/* Block If the Images are not present */}

            {(!selectedDiscipline?.images ||
              selectedDiscipline.images.length === 0) && (
              <SoftBox
                sx={{
                  px: {
                    xs: 2,
                    sm: 4,
                    md: 8,
                  },
                }}
              >
                <SoftButton
                  variant="contained"
                  component="label"
                  sx={{
                    outlined: "none",
                    backgroundColor: "#F1F4F8",
                    width: "100%",
                    height: 45,
                    color: "#02255B",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  onChange={handleImageUpload}
                >
                  Choose Photo
                  <input type="file" hidden multiple accept="image/*" />
                </SoftButton>
              </SoftBox>
            )}

            {/* Cancelled In router and contractor not ready Buttons*/}
            <SoftBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ px: { xs: 0, sm: 8 }, gap: { xs: 2, sm: 5 } }}
              pb={2}
            >
              <SoftBox
                borderRadius="8px"
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={1.5}
                sx={{
                  border: selectedDiscipline?.comment?.includes(
                    "Contractor not ready"
                  )
                    ? ""
                    : "1px solid #02255B",
                  backgroundColor: selectedDiscipline?.comment?.includes(
                    "Contractor not ready"
                  )
                    ? "info.main"
                    : "",
                  cursor: "pointer",
                }}
                onClick={() => handleAppendComment("Contractor not ready")}
              >
                <SoftTypography
                  fontSize="12px"
                  color={
                    selectedDiscipline?.comment?.includes(
                      "Contractor not ready"
                    )
                      ? "white"
                      : "primary"
                  }
                  fontWeight="bold"
                  textAlign="center"
                >
                  Contractor not ready
                </SoftTypography>
              </SoftBox>

              <SoftBox
                border="1px solid #02255B"
                borderRadius="8px"
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={1.5}
                sx={{
                  border: selectedDiscipline?.comment?.includes(
                    "Cancelled in route"
                  )
                    ? ""
                    : "1px solid #02255B",
                  backgroundColor: selectedDiscipline?.comment?.includes(
                    "Cancelled in route"
                  )
                    ? "info.main"
                    : "",
                  cursor: "pointer",
                }}
                onClick={() => handleAppendComment("Cancelled in route")}
              >
                <SoftTypography
                  fontSize="12px"
                  color={
                    selectedDiscipline?.comment?.includes("Cancelled in route")
                      ? "white"
                      : "primary"
                  }
                  fontWeight="bold"
                  textAlign="center"
                >
                  Cancelled in Route
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            {/* Action Buttons */}
            <DialogActions
              sx={{
                justifyContent: "center",
                flexDirection: "column",
                gap: 3,
                padding: "0px",
              }}
            >
              <SoftButton
                variant="gradient"
                color="primary"
                sx={{
                  width: "45%",
                  padding: "14px 24px",
                  fontSize: "16px",
                }}
                onClick={handleUpdateDiscipline}
              >
                {loading == true ? <CircularLoader type="small" /> : "Add"}
              </SoftButton>
              <SoftTypography
                fontSize="16px"
                fontWeight="bold"
                align="center"
                color="primary"
                sx={{ margin: "0px !important", cursor: "pointer" }}
                onClick={handleClose}
              >
                Cancel
              </SoftTypography>
            </DialogActions>
          </SoftBox>
        </DialogContent>
      </Dialog>

      {/* AddPredefined commnets */}
      <Dialog
        open={isOpencomment}
        onClose={handleCloseComment}
        maxWidth="md"
        fullWidth
        aria-labelledby="select-inspector-dialog"
        sx={{
          "& .MuiDialog-paper": {
            margin: 2,
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "white.main",
            padding: "18px 24px !important",
          }}
        >
          <SoftBox display="flex" flexDirection="column" gap={2}>
            <SoftBox
              mt={3}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              textAlign="center"
            >
              <SoftTypography
                fontSize="26px"
                fontWeight="bold"
                sx={{ color: "#212121" }}
              >
                PREDEFINED COMMENTS
              </SoftTypography>

              <SoftTypography
                fontSize="14px"
                fontWeight="400"
                sx={{
                  color: "#737373",
                  maxWidth: "70%",
                }}
              >
                Click on any option to edit or include in the comments.{" "}
              </SoftTypography>

              <SoftBox display="flex" gap={1.5} mt={2}>
                {Object.entries(predefinedCommentTypeStyles).map(
                  ([commentType, style]) => {
                    const isSelected = predefinedCommentType === commentType;

                    return (
                      <SoftButton
                        key={commentType}
                        variant="outlined"
                        size="small"
                        sx={{
                          backgroundColor: isSelected
                            ? `${style.color} !important`
                            : "transparent !important",
                          border: `1px solid ${style.color} !important`,
                          color: isSelected
                            ? "#FFFFFF !important"
                            : `${style.color} !important`,
                          boxShadow: "none !important",
                          "&:hover": {
                            backgroundColor: isSelected
                              ? `${style.color} !important`
                              : "transparent !important",
                            color: isSelected
                              ? "#FFFFFF !important"
                              : `${style.color} !important`,
                          },
                        }}
                        onClick={() => setPredefinedComments(commentType)}
                      >
                        {style.label}
                      </SoftButton>
                    );
                  }
                )}
              </SoftBox>
            </SoftBox>

            <SoftBox
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              textAlign="center"
              gap={1.5}
            >
              {predefinedcomments?.length > 0 ? (
                predefinedcomments?.map((comment, index) => (
                  <SoftTypography
                    key={comment?.comment_id || index}
                    fontSize="14px"
                    fontWeight="400"
                    color="primary"
                    sx={{
                      maxWidth: "90%",
                      cursor: "pointer",
                    }}
                    onClick={() => handleAppendComment(comment?.comment)}
                  >
                    {comment?.comment}
                  </SoftTypography>
                ))
              ) : (
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap={1}
                >
                  <SoftTypography
                    fontSize="40px"
                    fontWeight="light"
                    height="50px"
                    color="fade"
                  >
                    0
                  </SoftTypography>
                  <SoftTypography
                    fontSize="20px"
                    fontWeight="medium"
                    color="fade"
                  >
                    predefiend comments
                  </SoftTypography>
                  <EmptyFolderIcon
                    style={{
                      opacity: 0.8,
                      width: "100px",
                      height: "100px",
                    }}
                  />
                </SoftBox>
              )}
            </SoftBox>

            <DialogActions
              sx={{
                justifyContent: "center",
                flexDirection: "column",
                gap: 3,
                padding: "0px",
              }}
            >
              <SoftTypography
                fontSize="16px"
                fontWeight="bold"
                align="center"
                color="primary"
                sx={{ margin: "0px !important", cursor: "pointer" }}
                onClick={handleCloseComment}
              >
                Cancel
              </SoftTypography>
            </DialogActions>
          </SoftBox>
        </DialogContent>
      </Dialog>
    </>
  );
}
